import { useRouter } from 'next/router';
import React, { Fragment, useState } from 'react';
import Sticky from 'react-stickynode';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { isSeller } from 'Utils/seller/sellerUtils';
import { useAppContext } from 'Context/ReactAppContext';
import { t } from 'Src/i18n';
import type { AllInclusiveServicesData } from 'Store/price-remote/all-inclusive-services/allInclusiveServices.helper';
import 'Store/price-remote/all-inclusive-services/allInclusiveServices.helper';
import type { BlockLinkProps } from 'Components/frameworks/block-link/BlockLink';
import 'Components/frameworks/block-link/BlockLink';
import type { ButtonProps } from 'Components/frameworks/button/Button';
import 'Components/frameworks/button/Button';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { PriceTicketLarge } from 'Components/widgets/price-ticket-large/PriceTicketLarge';
import { PriceTicketNarrow } from 'Components/widgets/price-ticket-narrow/PriceTicketNarrow';
export type PriceTicketItem = {
  iconName: string;
  label?: string;
  longDesc?: string;
  shortDesc?: string;
  subDesc?: string;
};
export type PriceTicketContentProps = {
  allInclusiveServices?: AllInclusiveServicesData | null | undefined;
  blockLink?: BlockLinkProps;
  button?: ButtonProps;
  className?: string;
  closeLabel?: string;
  collapseLabel?: string;
  expandLabel?: string;
  fromPriceTicketCustom?: boolean;
  hasCallCenter?: boolean;
  id?: string;
  isLoading?: boolean;
  items?: Array<PriceTicketItem>;
  minHeight?: string;
  price?: {
    bestPrice?: FormattedPrice;
    currency?: string;
    unit?: string;
  };
  subtitle?: string;
  title?: string;
  travelAdvisorConfig?: CMSTravelAdvisor;
};
export const PriceTicketContentWrapper = (props: PriceTicketContentProps) => {
  const appContext = useAppContext();
  const router = useRouter();
  const { isDesktop } = useResponsive();
  const [isSticky, setIsSticky] = useState(false);

  const onStateChange = (status: any) => {
    setIsSticky(status.status !== Sticky.STATUS_ORIGINAL);
  };

  return (
    <Fragment>
      <SiteContainer>
        {isSeller(appContext) && (
          <button
            className="mb-10 flex items-center gap-5 text-sienna"
            data-testid="PriceTicketBackToSearch"
            onClick={router.back}
            type="button"
          >
            <Icon name={ICONS.ARROW_LEFT} hasRtl width="0.9rem" />
            {t('common.comparator.backToSearch')}
          </button>
        )}
      </SiteContainer>
      <Sticky
        activeClass="sticky-bottom"
        bottomBoundary=".PriceTicket-sticky-beacon"
        innerZ={6}
        onStateChange={onStateChange}
        releasedClass="opacity-0"
      >
        {isDesktop ? (
          <PriceTicketLarge {...props} isLite={isSticky} />
        ) : (
          <PriceTicketNarrow {...props} isLite={isSticky} />
        )}
      </Sticky>
    </Fragment>
  );
};
